// extracted by mini-css-extract-plugin
module.exports = {"mobileS":"320px","mobileM":"375px","mobileL":"425px","tablet":"768px","laptop":"1024px","laptopL":"1480px","desktop":"1600px"};